var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"0px"}},[_c('div',{staticClass:"QRCode",staticStyle:{"text-align":"center"}},[_c('canvas',{style:({ width: 150, height: 150 }),attrs:{"id":_vm.canvasId}})]),_c('div',[_vm._v("请出示二维码给客户扫码评价")])])
}
var staticRenderFns = []

export { render, staticRenderFns }